import { ApiClient } from "@/services/apiClient";
import { type ThemesTreeNode } from "@/services/collectibles/themes/types";
import { CategoryId } from "@/services/collection/categories";

const treePromiseCache: Map<CategoryId, Promise<ThemesTreeNode[]>> = new Map([]); // Do cache themes, fetch them only once

export const getThemesTree = async (categoryId: CategoryId): Promise<ThemesTreeNode[]> => {
  if (treePromiseCache.get(categoryId) === undefined) {
    const url = "api-public/themes";
    treePromiseCache.set(
      categoryId,
      ApiClient.getPublic<ThemesTreeNode[]>(url, { categoryId }).then(({ data }) => data)
    );
  }

  return treePromiseCache.get(categoryId)!;
};
